// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1653562692916
      var cssReload = require("C:/git/goproject/GOproject.WebApp/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"reloadAll":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  